import { gql } from '@apollo/client';
import { SURVEY_QUESTION_FIELDS } from '@/graphql/fragments/surveys';

// Shipper's authored LOAD_FEEDBACK questions, for the carrier's read-only view (no answers).
export const GET_SHIPPER_LOAD_FEEDBACK_QUESTIONS = gql`
    ${SURVEY_QUESTION_FIELDS}
    query ShipperLoadFeedbackQuestions($client_id: uuid!) {
        survey_questions(
            where: { client_id: { _eq: $client_id }, survey_type: { _eq: "LOAD_FEEDBACK" }, enabled: { _eq: true } }
        ) {
            ...SurveyQuestionFields
        }
    }
`;
